import React from "react";
import axiosInstance from "../redux/helpers/axios";

/**
 * @author
 * @function ActivityLogs
 **/

export const ActivityLogs = (props) => {
  const [page, setPage] = React.useState(1);
  const [logs, setLogs] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState(null);
  const [hasNextPage, setHasNextPage] = React.useState(false);
  const [hasPrevPage, setHasPrevPage] = React.useState(false);

  React.useEffect(() => {
    const fetchLogs = async () => {
      setLoading(true);
      setError(null);
      try {
        const response = await axiosInstance.get(
          `/admin/security/activity-logs?page=${page}`,
        );
        const data = response.data;
        if (response.status === 200) {
          setLogs(data.data);
          setHasNextPage(data.pagination.hasNextPage);
          setHasPrevPage(data.pagination.hasPrevPage);
        } else {
          setError(data.msg || "Failed to fetch logs");
        }
      } catch (err) {
        setError(err.message || "An error occurred");
      }
      setLoading(false);
    };
    fetchLogs();
  }, [page]);

  return (
    <div>
      <h1 className="text-2xl font-bold mb-4">Activity Logs</h1>

      {loading && <p>Loading...</p>}
      {error && <p className="text-red-500">{error}</p>}
      {!loading && !error && logs.length === 0 && <p>No logs found.</p>}

      {!loading && !error && logs.length > 0 && (
        <div className="space-y-2">
          {logs.map((log) => (
            <div
              key={log.id}
              className="flex items-center justify-between px-4 py-2 rounded-md bg-gray-100 hover:bg-gray-200 transition"
            >
              {/* Left side */}
              <div className="flex items-center gap-3 text-sm text-gray-700 truncate">
                <span className="text-gray-500 whitespace-nowrap hover:text-gray-700 hover:underline hover:cursor-pointer">
                  [{new Date(log.createdAt).toLocaleString()}]
                </span>

                <span className="font-medium text-gray-900">{log.action}</span>

                <span className="text-blue-700 truncate max-w-[240px]">
                  {log.route || log.endpoint}
                </span>

                <span
                  className={`text-xs font-semibold ${
                    log.status === "SUCCESS" ? "text-green-600" : "text-red-600"
                  }`}
                >
                  ({log.status})
                </span>
              </div>

              {/* Right side */}
              <div className="flex items-center gap-3 text-xs text-gray-600 whitespace-nowrap">
                <span>{log.adminEmail}</span>
                <span>IP: {log.ipAddress}</span>
                {log.method && <span>{log.method}</span>}
              </div>
            </div>
          ))}
        </div>
      )}

      {/* Pagination */}
      <div className="flex justify-between items-center mt-6">
        <button
          onClick={() => setPage((p) => Math.max(p - 1, 1))}
          disabled={!hasPrevPage}
          className="px-4 py-2 rounded bg-[#0F172A] text-white disabled:opacity-50"
        >
          Previous
        </button>

        <span className="text-sm text-gray-600">Page {page}</span>

        <button
          onClick={() => setPage((p) => p + 1)}
          disabled={!hasNextPage}
          className="px-4 py-2 rounded bg-[#0F172A] text-white disabled:opacity-50"
        >
          Next
        </button>
      </div>
    </div>
  );
};
